import { Tooltip } from "primereact/tooltip";
import { useTranslation } from "react-i18next";

export default function KH1000040001() {
  const { i18n } = useTranslation();

  if (i18n.language === "en") {
    return (
      <>
        <p>
          1. H.E. Hei Bavy
          <span className="vertical-align-super b text-xs text-yellow-500 pl-1">
            (b)
          </span>
          <Tooltip target=".b" position="right" event="both">
            Chairman of BOD and CEO
          </Tooltip>
        </p>
        <p>
          2. H.E. Suon Rachana
          <span className="vertical-align-super c text-xs text-yellow-500 pl-1">
            (c)
          </span>
          <Tooltip target=".c" position="right" event="both">
            Member (Rep.of Ministry of Public Works & Transport)
          </Tooltip>
        </p>
        <p>
          3. H.E. Ken Sambath
          <span className="vertical-align-super d text-xs text-yellow-500 pl-1">
            (d)
          </span>
          <Tooltip target=".d" position="right" event="both">
            Member (Rep. of Ministry of Economy & Finance)
          </Tooltip>
        </p>
        <p>
          4. H.E. Penn Sovicheat
          <span className="vertical-align-super e text-xs text-yellow-500 pl-1">
            (e)
          </span>
          <Tooltip target=".e" position="right" event="both">
            Member (Rep. of Ministry of Commerce)
          </Tooltip>
        </p>
        <p>
          5. Mr. Gui Anvanith
          <span className="vertical-align-super f text-xs text-yellow-500 pl-1">
            (f)
          </span>
          <Tooltip target=".f" position="right" event="both">
            Member (Independent Director)
          </Tooltip>
        </p>
        <p>
          6. Mrs. Pok Pheakdey
          <span className="vertical-align-super g text-xs text-yellow-500 pl-1">
            (g)
          </span>
          <Tooltip target=".g" position="right" event="both">
            Member (Non-Executive Director, Rep.of Private Shareholders)
          </Tooltip>
        </p>
        <p>
          7. Mr. Kong Sothea
          <span className="vertical-align-super h text-xs text-yellow-500 pl-1">
            (h)
          </span>
          <Tooltip target=".h" position="right" event="both">
            Member (Rep. of PPAP Employees)
          </Tooltip>
        </p>
      </>
    );
  }
  return (
    <>
      <p>
        ១. ឯកឧត្តម ហ៊ឺ បាវី
        <span className="vertical-align-super b text-xs text-yellow-500 pl-1">
          (b)
        </span>
        <Tooltip target=".b" position="right" event="both">
          ប្រធានក្រុមប្រឹក្សាភិបាល និងជាអគ្គនាយក
        </Tooltip>
      </p>
      <p>
        ២. ឯកឧត្តម សួន រចនា
        <span className="vertical-align-super c text-xs text-yellow-500 pl-1">
          (c)
        </span>
        <Tooltip target=".c" position="right" event="both">
          សមាជិក (តំណាងក្រសួងសាធារណការ និងដឹកជញ្ជូន)
        </Tooltip>
      </p>
      <p>
        ៣. ឯកឧត្តម កែន សម្បត្តិ
        <span className="vertical-align-super d text-xs text-yellow-500 pl-1">
          (d)
        </span>
        <Tooltip target=".d" position="right" event="both">
          សមាជិក (តំណាងក្រសួងសេដ្ឋកិច្ច និងហិរញ្ញវត្ថុ)
        </Tooltip>
      </p>
      <p>
        ៤. ឯកឧត្តម ប៉ែន សុវិជាតិ
        <span className="vertical-align-super e text-xs text-yellow-500 pl-1">
          (e)
        </span>
        <Tooltip target=".e" position="right" event="both">
          សមាជិក (តំណាងក្រសួងពាណិជ្ជកម្ម)
        </Tooltip>
      </p>
      <p>
        ៥. លោក ហ្គី អានវ៉ានិថ
        <span className="vertical-align-super f text-xs text-yellow-500 pl-1">
          (f)
        </span>
        <Tooltip target=".f" position="right" event="both">
          សមាជិក (អភិបាលឯករាជ្យ)
        </Tooltip>
      </p>
      <p>
        ៦. អ្នកស្រី ប៉ុក ភក្តី
        <span className="vertical-align-super g text-xs text-yellow-500 pl-1">
          (g)
        </span>
        <Tooltip target=".g" position="right" event="both">
          សមាជិក (អភិបាលមិនប្រតិបត្តិតំណាងភាគហ៊ុនិកឯកជន)
        </Tooltip>
      </p>
      <p>
        ៧. លោក គង់ សុធា
        <span className="vertical-align-super h text-xs text-yellow-500 pl-1">
          (h)
        </span>
        <Tooltip target=".h" position="right" event="both">
          សមាជិក (តំណាងនិយោជិត ក.ស.ភ)
        </Tooltip>
      </p>
    </>
  );
}
